<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">用户注册列表</span>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="输入姓名搜索" v-model="searchParams.realName" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-select
            placeholder="请选择"
            v-model="searchParams.state"
            class="search-select"
        >
          <a-select-option value="待审核">
            待审核
          </a-select-option>
          <a-select-option value="审核通过">
            审核通过
          </a-select-option>
          <a-select-option value="审核拒绝">
            审核不通过
          </a-select-option>
        </a-select>
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button
        >
        <a-button @click="onReset">重置</a-button>
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a v-if="record.state === '待审核'" @click="onAccept(record)">通过</a>
            <a v-if="record.state === '待审核'" @click="onReject(record)">拒绝</a>
            <span v-if="record.state !== '待审核'">--</span>
          </a-space>
        </a-table>
      </div>
    </div>

    <a-modal
        title="设置资源合作方"
        :visible="visible"
        :confirm-loading="confirmLoading"
        okText="确定"
        cancelText="取消"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <a-row class="modal-row">
        <a-col :span="6" class="input-label">姓名</a-col>
        <a-col :span="18">{{curAuditRecord.realName}}</a-col>
      </a-row>
      <a-row class="modal-row">
        <a-col :span="6" class="input-label">资源合作方</a-col>
        <a-col :span="18">
          <a-select
              v-model="curAuditRecord.partnerId"
              placeholder="请选择"
              style="width: 96%"
          >
            <a-select-option v-for="partner in partnerOptions" :value="partner.partnerId" :key="partner.partnerId">
              {{ partner.partnerName }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="18" offset="6" class="hint-txt">用户填写：{{curAuditRecord.partnerName}}</a-col>
      </a-row>
    </a-modal>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import { fetchRegisterUserList, auditRegisterUser } from "@/services/UserService";
import {listOptions} from "@/views/partner/PartnerApi";

const tblColumns = [
  {
    title: "姓名",
    dataIndex: "realName",
    width: "10%"
  },
  {
    title: "手机",
    dataIndex: "mobile",
    width: "15%"
  },
  {
    title: "资源合作方",
    dataIndex: "partnerName",
    width: "20%"
  },
  {
    title: "注册时间",
    dataIndex: "createTime",
    width: "15%"
  },
  {
    title: "审核",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];

export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      tblData: [],
      roleList: [],
      searchParams: {
        realName: "",
        state: "待审核"
      },
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      curAuditRecord: {},
      partnerOptions: [],
      loading: false,
      visible: false,
      confirmLoading: false
    };
  },
  computed: {
  },
  mounted() {
    this.fetchList();
    this.fetchPartnerOptions();
  },
  methods: {
    handleOk() {
      if(this.curAuditRecord.partnerId === '' || this.curAuditRecord.partnerId === undefined) {
        this.$message.error('请选择资源合作方');
        return;
      } else {
        let params = {
          registerId: this.curAuditRecord.registerId,
          partnerId: this.curAuditRecord.partnerId,
          opinion: 'pass',
          roleId: 'sales'
        }
        this.onAudit(params);
      }

    },
    handleCancel() {
      this.visible = false;
    },
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.projectName = "";
      this.searchParams.state = "";
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };

      fetchRegisterUserList(params).then(response => {
        this.loading = false;
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
          this.$message.error("读取数据失败");
        } else {
          this.setTblData(response);
        }
      });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
          if (item.auditTime) {
            item.auditTime = tsFormat(item.auditTime);
          }
        });
      }
      this.tblData = rltList;
      const pagination = {...this.pagination};
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    fetchPartnerOptions() {
      listOptions().then(response => {
        if (response.data.code === "SUCCESS") {
          this.partnerOptions = response.data.data;
        }
      });
    },
    onAccept(record) {
      this.curAuditRecord = record;
      this.visible = true;
    },
    onReject(record) {
      let that = this;
      this.$confirm({
        title: `确定不同意【${record.realName}】的注册申请?`,
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          let params = {
            registerId: record.registerId,
            opinion: 'reject',
            roleId: 'sales'
          }
          that.onAudit(params);
        }
      });
    },
    onAudit(params) {
      if(this.visible===true) {
        this.confirmLoading = true;
      }
      auditRegisterUser(params).then(resp => {
        if(this.visible===true) {
          this.confirmLoading = false;
          this.visible = false;
        }
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.fetchList();
        } else {
          this.$message.error("操作失败:" + resp.data.errorMsg);
        }
      });
    }


  }
};
</script>

<style scoped>
.modal-row {
  padding-top: 10px;
  padding-bottom: 10px;
}
.input-label {
  font-weight: bold;
}
.hint-txt{
  color: #999;
  font-size: 12px;
}
</style>
